<template>
  <div>
    <div>
      <b-card
        no-body
      >
        <div
          class="m-2"
        >
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
            >
              <div>
                <ReportTableButtons
                  :items="items"
                  :json_fieldz="json_fields"
                  :name="`${reportName} - Page ${page}.xls`"
                  :bulkname="`${reportName}.xls`"
                  :fetch="fetchOperationalOrdersByStatusNoPagination"
                  @refresh="fetchOperationalOrdersByStatus"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay
          id="overlay-background"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :json_fields="json_fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            show-empty
            sticky-header="100vh"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #cell(waybill_number)="data">
              <div
                class="d-flex align-items-center"
              >
                <div>
                  <div
                    :class="'font-weight-bolder ml-1 text-primary'"
                    @click="onClickViewOrder(data.item.id)"
                  >
                    {{ data.value }}
                  </div>
                  <div class="font-small-2 ml-1">
                    {{ __dateTimeFormatter(data.item.created_at) }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(merchant_data.name)="data">
              <div>{{ data.value ? data.value : 'Walking Customer' }}</div>
            </template>
            <template #cell(latest_status_updated_at)="data">
              {{ __dateTimeFormatter(data.value) }}
            </template>
            <template #cell(cod)="data">
              {{ __numberWithCommas(data.value, true) }}
            </template>
            <template #cell(collected_cod)="data">
              {{ __numberWithCommas(data.value, true) }}
            </template>
            <template #cell(delivery_charge)="data">
              {{ __numberWithCommas(data.value, true) }}
            </template>
          </b-table>
        </b-overlay>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-sm-start"
            >
              <label>Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block ml-1 width-125"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              md="9"
              class="d-flex align-items-center justify-content-sm-end"
            >
              <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <view-order-modal ref="viewOrderModal" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  // BFormGroup,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BPagination,
} from 'bootstrap-vue'
// import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
// import flatPickr from 'vue-flatpickr-component'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
// import FilterButtons from '@/components/Filter/ReportFilterButtons.vue'
import getWarehouseList from '../ReturnOrderOriginWarehouse/WarehouseListDropdown'

const ReportRepository = RepositoryFactory.get('report')

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // BCardActions,
    vSelect,
    // flatPickr,
    BCard,
    BTable,
    BRow,
    BCol,
    // BFormGroup,
    BOverlay,
    BPagination,
    // FilterButtons,
    ViewOrderModal,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  props: {
    reportKey: {
      type: String,
      required: true, // Ensure the prop is passed
    },
    reportName: {
      type: String,
      required: true, // Ensure the prop is passed
    },
  },
  data() {
    return {
      warehouseOptions: [],
      filters: {},
      tableData: [],
      merchantOptions: [],
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 200],
      totalRows: 1,
      page: 1,
      meta: {},
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [],
      json_fields: {
        'Latest Status Updated At': {
          field: 'latest_status_updated_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant_data.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        COD: 'cod',
        'Collected Cod': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
      },
      currentDate: '',
      todayFilterQuery: '',
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchOperationalOrdersByStatus()
      },
    },
    deep: true,
    page() {
      this.fetchOperationalOrdersByStatus()
    },
    perPage() {
      this.fetchOperationalOrdersByStatus()
    },
  },
  mounted() {
    this.fields.push(
      {
        key: 'latest_status_updated_at',
        label: 'Latest Status Updated At',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'waybill_number',
        label: 'Waybill Number',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'merchant_data.name',
        label: 'Merchant',
        thClass: 'text-left',
        tdClass: 'text-left',
        sortable: true,
      },
      {
        key: 'destination_warehouse.name',
        label: 'Destination Warehouse',
        thClass: 'text-left',
        tdClass: 'text-left',
        sortable: true,
      },
      {
        key: 'cod',
        label: `COD(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
      {
        key: 'collected_cod',
        label: `Collected COD(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
      {
        key: 'delivery_charge',
        label: `Delivery Charge(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
    this.fetchOperationalOrdersByStatus()
    // this.warehouseList()
  },
  methods: {
    async fetchOperationalOrdersByStatus() {
      this.dataLoading = true
      this.items = []
      try {
        const { data } = (await ReportRepository.fetchOperationalOrdersByStatus(this.reportKey, this.page, this.filterQuery, this.perPage))
        // fiter the default date or selected date for table data and meta data
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchOperationalOrdersByStatusNoPagination() {
      try {
        const { data } = (await ReportRepository.fetchOperationalOrdersByStatusNoPagination(this.reportKey, this.filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async warehouseList() {
      this.warehouseOptions = await getWarehouseList()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchOperationalOrdersByStatus()
    },
    applyFilters() {
      this.fetchOperationalOrdersByStatus()
    },
    clearFilters() {
      this.filters = {}
      this.$nextTick(() => {
        this.fetchOperationalOrdersByStatus()
      })
    },

    clearDate(filterKey) {
      this.filters[filterKey] = ''
    },
    onClickViewOrder(id) {
      this.$refs.viewOrderModal.openModal(id)
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select';
@import '../../../@core/scss/vue/libs/vue-flatpicker';
</style>
